export var slugifyTitle = function (text) {
    return text
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
};
export var sortSlugs = function (a, b) {
    if (a.isDefault !== b.isDefault) {
        return a.isDefault ? -1 : 1;
    }
    return a.slug.localeCompare(b.slug);
};
export var getDefaultSlugFromSlugs = function (slugs) { var _a, _b; return (_b = (_a = slugs === null || slugs === void 0 ? void 0 : slugs.find(function (s) { return s.isDefault; })) === null || _a === void 0 ? void 0 : _a.slug) !== null && _b !== void 0 ? _b : ""; };
